
import { jsPDF } from "jspdf";

export const addFooterToPage = (pdf: jsPDF, pageWidth: number, pageHeight: number, margin: number) => {
  const footerY = pageHeight - 15;
  
  // Add subtle footer line
  pdf.setDrawColor(155, 135, 245, 0.3);
  pdf.setLineWidth(0.5);
  pdf.line(margin, footerY - 5, pageWidth - margin, footerY - 5);

  // Add footer text
  pdf.setFontSize(8);
  pdf.setTextColor(142, 145, 150);
  pdf.text('Studio by thePlasticsFella', margin, footerY);

  // Add timestamp in footer
  const exportTime = new Date().toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  pdf.text(exportTime, pageWidth - margin - pdf.getTextWidth(exportTime), footerY);

  return 20;
};
